// VVS quick-add prefetch on hover — precharge le modal content avant que l'user clique
(() => {
  const prefetched = new Set();
  const prefetchUrl = (url) => {
    if (!url || prefetched.has(url)) return;
    prefetched.add(url);
    // Use link rel="prefetch" to let browser handle it
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url;
    document.head.appendChild(link);
  };

  const onHover = (e) => {
    const card = e.target.closest('product-card, product-hotspot-component');
    if (!card) return;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    prefetchUrl(link.href);
  };

  // Attach on grid product cards
  document.addEventListener('pointerenter', onHover, true);
  document.addEventListener('focusin', onHover, true);
})();
